module.exports = function () {

    let module = {};

    let results = {};

    let reportFormValidator;

    // Initial values
    module.values = $('.report-repair-form').data('values');

    module.loadHashSection = function () {
        let url = window.location.href;
        let hash = url.substring(url.indexOf("#") + 1) ?? 1;

        if (url.includes('#') && hash) {
            console.log('Hash #' + hash + ' detected. Loading section requested.');
            module.loadSection(hash);
        }
    };


    module.loadSection = function (id) {

        let section = $('.report-repair-form section#' + id);
        let steps = $('.report-repair-form section').length;

        console.log('Loading section ' + section.data('id') + '/' + steps)


        $('.report-repair-form section').removeClass('active');
        section.addClass('active');

        // Remove click bindings
        $('.steps-container .btn')
            .off('click', module.nextPrevSection)
            .off('click', module.finish);


        $('.steps-nav .step').removeClass('active');
        $('.steps-nav .step-' + section.data('id')).addClass('active');


        if (section.data('id') == 1) {
            $('.steps-container .btn.previous').addClass('disabled').off('click', module.nextPrevSection);
            $('.steps-container .btn.next').on('click', module.nextPrevSection);

        } else if (section.data('id') == steps) {
            $('.steps-container .btn.previous').on('click', module.nextPrevSection);

            $('.steps-container .btn.next')
                .html('Submit')
                .addClass('submit')
                .on('click', module.finish);

        } else {
            // Disable/enable back/prev buttons
            $('.steps-container .btn.previous').on('click', module.nextPrevSection).removeClass('disabled');

            $('.steps-container .btn.next').html('Next Step')
                .on('click', module.nextPrevSection);
        }

    };


    module.detectInputChange = function () {

        if ($('.report-repair-form').length) {
            $(".form-control,.form-check-input,.confirm, input[type='checkbox']").on('change', function () {
                $.each($('.report-repair-form').serializeControls(), function (index, value) {
                    module.values[index] = value;
                });
                module.setValues();

                $('.pretty.disability input').unbind().click(function () {
                    // Trigger  change
                    $('.form-control:first').trigger('change');
                });

            });

        }

    }

    module.finish = function () {

        if (module.checkValid() === true) {

            $('body').addClass('loading');
            $('form.report-repair-form').submit();
        }
    };

    module.formSetup = function () {

        $('.steps-container .btn.next,.submit')
            .addClass('submit')
            .on('click', module.nextPrevSection);

    }

    module.checkValid = function () {
        module.reportFormValidator.form();

        if (module.reportFormValidator.numberOfInvalids()) {
            console.log('Form validation invalid - ' + module.reportFormValidator.numberOfInvalids() + ' errors')
            module.reportFormValidator.showErrors();

            return false;
        }

        return true;
    };


    module.initFormValidation = function () {
        require('jquery-validation');


        module.reportFormValidator = $('.report-repair-form').validate({ // initialize the plugin
            errorClass: 'alert alert-danger',
            rules: {

                name: {
                    required: true,
                    minlength: 2
                },
                email: {
                    required: true,
                    email: true
                },
                phone: {
                    required: true,
                },
                mobile: {
                    required: true,
                },
                accommodation_id: {
                    required: true,
                },

                confirm: {
                    required: true,
                },


            }
        });
    };

    module.nextPrevSection = function () {

        let btn = $(this);

        if (btn.hasClass('next')) {
            if (module.checkValid())
                module.runNextPrev(btn);
        } else
            module.runNextPrev(btn);
    };

    module.runNextPrev = function (btn) {
        $('body').addClass('loading');

        setTimeout(function () {

            let thisSection = $('.report-repair-form section.active');
            let prevSection = thisSection.prev('section');
            let nextSection = thisSection.next('section');
            let newSection;

            // Set new section
            if (btn.hasClass('previous')) {
                newSection = prevSection;
            } else {
                newSection = nextSection;

                if (!newSection.length) {
                    newSection = thisSection;
                }
            }

            thisSection.removeClass('active');

            module.loadSection(newSection.attr('id'));

            window.scrollTo(0, 0);

            $('body').removeClass('loading');

        }, 500);
    }


    module.initSteps = function () {
        $('.steps-container .btn').click(module.nextPrevSection);
    };


    module.getValues = function () {

        $.ajax({
            type: "GET",
            url: "/getValues",
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            success: function (data) {
                //module.values = $.parseJSON(data);
                module.values = data;

                //module.initTableStyles();

            },
        });

    };

    module.setValues = function () {

        $.ajax({
            type: "POST",
            url: "/postValues",
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: {values: $('form').serializeControls()},
            success: function (data) {
                //module.initTableStyles();
                refreshReCaptchaV3('report_repair_id','report_repair');

                console.log('Values stored in session');
            },
            error: function(err){
                refreshReCaptchaV3('report_repair_id','report_repair');
            }

        });

    };


    return module;

};
